module.exports = __webpack_public_path__ + "static/media/11_APOTHEO_LABO_ENOVIS.fc51c484.png";